import { Tag } from '@visualfabriq/vf-ui-kit';

export function StepHeading({ displayName, isDraft }: { displayName: string; isDraft: boolean }) {
  return (
    <>
      {displayName} {isDraft && <Tag color="orange">Draft</Tag>}
    </>
  );
}
